var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLayerBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_326_1260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1987 11.1017L19.6828 14.7766C20.0845 14.9506 20.0845 15.5202 19.6828 15.6942L11.1987 19.3691C11.0719 19.4241 10.9281 19.4241 10.8013 19.3691L2.31718 15.6942C1.91549 15.5202 1.9155 14.9506 2.31718 14.7766L10.8013 11.1017C10.9281 11.0468 11.0719 11.0468 11.1987 11.1017Z",
    fill: "white",
    stroke: "#496DED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1987 6.86633L19.6828 10.5412C20.0845 10.7152 20.0845 11.2849 19.6828 11.4589L11.1987 15.1338C11.0719 15.1887 10.9281 15.1887 10.8013 15.1338L2.31718 11.4589C1.91549 11.2849 1.9155 10.7152 2.31718 10.5412L10.8013 6.86633C10.9281 6.8114 11.0719 6.8114 11.1987 6.86633Z",
    fill: "white",
    stroke: "#496DED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1987 2.63097L19.6828 6.3059C20.0845 6.47989 20.0845 7.04952 19.6828 7.22351L11.1987 10.8984C11.0719 10.9534 10.9281 10.9534 10.8013 10.8984L2.31718 7.22351C1.91549 7.04952 1.9155 6.47989 2.31718 6.3059L10.8013 2.63097C10.9281 2.57605 11.0719 2.57605 11.1987 2.63097Z",
    fill: "white",
    stroke: "#496DED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_326_1260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayerBlue);
export default __webpack_public_path__ + "static/media/layer-blue.2e54530db9ac4b0df2905531003524f4.svg";
export { ForwardRef as ReactComponent };